console.log(process.env.REACT_APP_ENVIRONMENT, "env");
export default {
  // API_BASEPATH: 'http://localhost:3000',

  API_BASEPATH:
    process.env.REACT_APP_API_BASEPATH ||
    (String(process.env.REACT_APP_ENVIRONMENT).toLowerCase() === "dev"
      ? "https://crm.salarymates.com/api"
      : // : "https://crm.advancesalary.in/api",
        "https://crm.salarymates.com/api"),

  // API_BASEPATH:"https://dev.paisaonsalary.in/api",

  // API_BASEPATH: 'https://api.speedoloan.com/api',
  // API_BASEPATH: '',//uat
  loan: {
    SEND_OTP: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    VERIFY_OTP:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    GET_DASHBOARD: "/Api/Website/InstantJourneyController/getDashboardData",
    VERIFY_PAN:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    PERSONAL_DETAILS:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    INCOME_DETAILS:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    ADDRESS_DETAILS:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    CUSTOMER_DOCUMENT: "/Api/Website/InstantJourneyController/saveleadDetails",
    STATE_CITY_PINCODE: "/Api/MasterController/masterAPI",
    UPLOAD_PROFILE_PIC:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    PROFILE_PIC:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",

    REFERENCE_DETAILS: "/Api/Website/InstantJourneyController/saveleadDetails",
    CHECK_ELIGIBILITY:
      "/Api/Website/InstantJourneyController/appCustomerRegisteration",
    ABOUT_COMPANY: "/Api/Website/InstantJourneyController/saveleadDetails",
    CALCULATE_LOAN: "/Api/Website/InstantJourneyController/saveleadDetails",
    USER_DATA: "/Api/Website/getUser", //missing api
    ALL_LEADS: "/Api/Website/InstantJourneyController/getLeadList",
    LOAN_DETAIL: "/Api/Website/InstantJourneyController/getLeadDetail",
    GENERATE_LOAN: "/Api/Website/InstantJourneyController/saveleadDetails",
    GENERATE_ORDER_ID:
      "/Api/Website/InstantJourneyController/generateRazorpayorderId",
    MANDATORY_DOCS:
      "/Api/Website/InstantJourneyController/check_customer_mandatory_documents",
  },
};
